export const defaultColour = '#A9A9A9'; // Fallback color for undefined or unknown values

export const waterClarityColours: { [key: string]: string } = {
  '1 - Too muddy to see below surface': '#26312b',
  '2 - Muddy can see into water': '#007093',
  '3 - Cloudy can see into water': '#00b1d8',
  '4 - Cloudy but can see bed': '#66c39b',
  '5 - I can see the bottom easily': '#df42f7',
};

export const riparianColours: { [key: string]: string } = {
  None: '#26312b',
  Some: '#446351',
  Half: '#507a5f',
  'Three quarters': '#4b9e78',
  'Completely covered': '#66c39b',
};

export const waterColours: { [key: string]: string } = {
  'Kikorangi | Blue': '#007093',
  'Kikorangi-kākāriki | Blue-Green': '#00b1d8',
  'Kikorangi-parauri | Blue-brown': '#3b5e59',
  'Kākāriki | Green': '#00916f',
  'Kākāriki-kikorangi | Green-blue': '#66c39b',
  'Kākāriki-parauri | Green-brown': '#6f744c',
  'Parauri | Brown': '#8b6f47',
};

export const mauriColours: { [key: string]: string } = {
  'Mauri Ora - Active Mauri/Wellbeing': '#00b1d8',
  'Mauri Tu - Resilient Mauri': '#8c7ebb',
  'Mauri Oho - Awakened Mauri': '#f26b4b',
  'Mauri Moe - Dormant Mauri': '#66c39b',
  'Mauri Rere - Unstable Mauri': '#ee4891',
};

export function getWaterClarityColour(value: string): string {
  return waterClarityColours[value] ?? defaultColour;
}

export function getRiparianColour(value: string): string {
  return riparianColours[value] ?? defaultColour;
}

export function getWaterColour(value: string): string {
  return waterColours[value] ?? defaultColour;
}

export function getMauriColour(value: string): string {
  return mauriColours[value] ?? defaultColour;
}
